import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ValorEstoqueExcel(produtos) {
  const dados = produtos.map((produto) => {
    const estoque = Number(produto.ESTOQUE);
    const valorCompra = Number(produto.COMPRA) * estoque;
    const valorVenda = Number(produto.VENDA) * estoque;
    const lucro = valorVenda - valorCompra;

    const icms = (lucro * Number(produto.ICMS_IN || 0)) / 100;
    const pis = (lucro * Number(produto.ALI_PIS_DEBITO || 0)) / 100;
    const cofins = (lucro * Number(produto.ALI_COFINS_DEBITO || 0)) / 100;

    const formatMoeda = (valor) => `R$ ${valor.toFixed(2).replace('.', ',')}`;

    return {
      Código: produto.COD_PRODUTO,
      Descrição: produto.DESCRICAO,
      Unidade: produto.UNIDADE,
      Estoque: estoque.toFixed(3).replace('.', ','),
      "Valor Compra": formatMoeda(valorCompra),
      "Valor Venda": formatMoeda(valorVenda),
      ICMS: formatMoeda(icms),
      PIS: formatMoeda(pis),
      COFINS: formatMoeda(cofins)
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(dados);

  worksheet["!cols"] = [
    { wch: 15 },  // Código
    { wch: 40 },  // Descrição
    { wch: 10 },  // Unidade
    { wch: 12 },  // Estoque
    { wch: 18 },  // Valor Compra
    { wch: 18 },  // Valor Venda
    { wch: 12 },  // ICMS
    { wch: 12 },  // PIS
    { wch: 12 },  // COFINS
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "ValorEstoque");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "Relatorio_ValorEstoque.xlsx");
}

export default ValorEstoqueExcel;